import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CaixaListarRoutingModule } from './caixa-listar-routing.module';
import { CaixaListarComponent } from './caixa-listar.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
  declarations: [CaixaListarComponent],
  imports: [
    CommonModule,
    CaixaListarRoutingModule,
    FormsModule,
    TableModule,
    DividerModule,
    DropdownModule,
    ProgressSpinnerModule,
    MessagesModule,
    ConfirmDialogModule,
    InputTextModule,
    SplitButtonModule,
    DialogModule,
    CalendarModule,
    InputNumberModule
  ],
  providers: [ConfirmationService, DatePipe]
})
export class CaixaListarModule { }
